/**
 * Single source of truth for the client/contract commission percentage:
 * default value, allowed range and precision.
 *
 * Mirrors backend `MagiaLecha.Core/Constants/CommissionLimits.cs` - change both together.
 * Unrelated to agent/organization approval commissions, which must not use this module.
 */

export const DEFAULT_COMMISSION_PERCENTAGE = 12.25;

export const MIN_COMMISSION_PERCENTAGE = 0.01;

export const MAX_COMMISSION_PERCENTAGE = 100;

/** Matches the decimal(5,2) columns that store the percentage */
export const COMMISSION_DECIMAL_PLACES = 2;

/** `step` for number inputs, so the browser accepts values such as 12.25 */
export const COMMISSION_STEP = 0.01;

/** מחזיר הודעת שגיאה בעברית אם הערך אינו תקין, אחרת null */
export const validateCommissionPercentage = (value: number | null | undefined): string | null => {
  if (value == null || Number.isNaN(value)) return 'אחוז עמלה הוא שדה חובה';

  if (value < MIN_COMMISSION_PERCENTAGE || value > MAX_COMMISSION_PERCENTAGE) {
    return `אחוז העמלה חייב להיות בין ${MIN_COMMISSION_PERCENTAGE} ל-${MAX_COMMISSION_PERCENTAGE}`;
  }

  // Tolerance absorbs float noise (e.g. 0.29 * 100 = 28.999999999999996)
  const scaled = value * 10 ** COMMISSION_DECIMAL_PLACES;
  if (Math.abs(scaled - Math.round(scaled)) > 1e-6) {
    return `אחוז העמלה יכול לכלול עד ${COMMISSION_DECIMAL_PLACES} ספרות אחרי הנקודה`;
  }

  return null;
};

/** Up to 2 decimals without trailing zeros: 12.25 -> "12.25", 20 -> "20" */
export const formatCommissionPercentage = (value: number): string =>
  String(Number(value.toFixed(COMMISSION_DECIMAL_PLACES)));
